<div class="show-message">
  <app-centered-scrollable-content>

    <sc-flex vertical [centered]="true" fitHeight>
      @if (validationMessages != null && validationMessages.length > 0) {
        @for (msg of validationMessages; track msg) {
          <h2>
            <sc-dictionary-label [dictionaryKey]="msg.message"></sc-dictionary-label>
          </h2>
        }
      }
    </sc-flex>

  </app-centered-scrollable-content>
</div>
